<template>
  <div
    v-if="layout === 'single'"
    class="pageComponent single"
    :class="{ 'no-padding': !!noPadding }"
  >
    <slot />
  </div>
  <div
    v-else-if="layout === 'double'"
    class="pageComponent double"
    :class="{ 'no-padding': !!noPadding, inverted }"
  >
    <div class="pageComponent__left">
      <slot name="left" />
    </div>
    <div class="pageComponent__right">
      <slot name="right" />
    </div>
  </div>
</template>

<script>
export default {
  name: "Page",
  props: {
    layout: {
      type: String,
      default: 'single'
    },
    noPadding: {
      type: Boolean,
      default: false
    },
    inverted: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
$c: '.pageComponent';

#{$c} {
  &.single,
  &.double {
    &.no-padding {
      padding: 0;
    }
  }

  &.single {
    background-color: #ffffff;
    padding: 20px 0;

    @include respond-below(sm) {
      padding: 10px;
    }
    @include respond-below(xs) {
      padding: 2px;
    }
  }

  &.double {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    flex-wrap: wrap;

    &.inverted {
      #{$c}__left {
        @include respond-below(lg) {
          flex: 100% 0;
        }
        flex: 65% 0;
      }

      #{$c}__right {
        @include respond-below(lg) {
          margin-top: 24px;
          flex: 100% 0;
        }
        flex: 30% 0;
      }
    }

    #{$c}__left {
      position: relative;
      min-width: 0;
    }

    #{$c}__left {
      @include respond-below(lg) {
        flex: 100% 0;
      }

      flex: 30% 0;
    }

    #{$c}__right {
      @include respond-below(lg) {
        margin-top: 24px;
        flex: 100% 0;
      }

      flex: 65% 0;
    }
  }
}
</style>